import { z } from 'zod';
/**
 * What is new in Kanos (after Corly's announcements): written by the Kanos team in the platform,
 * shown to the people of the firms in the help menu from the time it is published. The same for
 * every firm - no data of a firm in it.
 */
export const AnnouncementInput = z
    .object({
    title: z.string().trim().min(3).max(120),
    /** Plain text; an empty line starts a new paragraph (`paragraphsOf`). */
    body: z.string().trim().min(10).max(3000),
    /** From when the firms see it; one in the future waits until then. */
    publishedAt: z.iso.datetime({ offset: true }),
})
    .meta({ id: 'AnnouncementInput' });
export const Announcement = AnnouncementInput.extend({
    id: z.uuid(),
    updatedAt: z.iso.datetime({ offset: true }),
}).meta({ id: 'Announcement' });
export const AnnouncementList = z.array(Announcement).meta({ id: 'AnnouncementList' });
/** What a person of a firm reads: the published ones, newest first, and which they have not seen. */
export const AnnouncementFeed = z
    .object({
    items: z.array(Announcement.extend({ unread: z.boolean() })),
})
    .meta({ id: 'AnnouncementFeed' });
export const AnnouncementParams = z
    .object({ announcementId: z.uuid() })
    .meta({ id: 'AnnouncementParams' });
/** How many a firm's people see at most: the newest. */
export const ANNOUNCEMENT_FEED_SIZE = 20;
//# sourceMappingURL=announcements.js.map